import { type LucideIcon } from 'lucide-react';
import { type ReactElement } from 'react';

export interface InfoRowProps {
  data: string;
  icon: LucideIcon;
}

export const InfoRow = ({ data, icon: Icon }: InfoRowProps): ReactElement => (
  <div className="flex gap-2">
    <Icon className="size-4 text-gray-500" />
    <span className="text-sm">{data}</span>
  </div>
);
